/// <summary>
/// Rounds a given number to the specified number of decimal places using Banker's Rounding.
/// Banker's Rounding, also known as round half to even, rounds to the nearest even number
/// when the number is exactly halfway between two values.
/// This is a direct copy of the All services project Data Transformer class function called BankersRound
/// </summary>
/// <param name="num">The number to be rounded.</param>
/// <param name="decimalPlaces">The number of decimal places to round to.</param>
/// <returns>The rounded number.</returns>
export const bankersRound = (num: number, decimalPlaces: number) => {
    const d = decimalPlaces || 0;
    const m = 10 ** d;
    const n = +(d ? num * m : num).toFixed(8); // Avoid rounding errors
    const i = Math.floor(n);
    const f = n - i;
    const e = 1e-8; // Allow for rounding errors in f
    const r = f > 0.5 - e && f < 0.5 + e ? (i % 2 === 0 ? i : i + 1) : Math.round(n);
    return d ? r / m : r;
};

export const FormatNumberForChart = (numIn?: number | string | null): string | undefined | null => {
    if (numIn === undefined || numIn === null) return null;

    // Convert input to string to preserve decimal places
    const numStr = numIn?.toString();
    const num = Number(numIn);

    if (isNaN(num)) return undefined;

    // Check if the string input has decimal places
    if (numStr.includes('.')) {
        // If the number has decimal places, round it to two decimal places using banker's rounding
        const roundedNum = bankersRound(num, 2);
        return roundedNum.toFixed(2);
    }

    // If the number is an integer, return it as is
    return num.toString();
};
